import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import OutsourcedUserFteService from '../../Services/OutsourcedUserFte/OutsourcedUserFteService';

class ReverseIobItem {
  constructor(fteEntryIds, toOfficeId, toOfficeName) {
    this.FteEntryIds = fteEntryIds;
    this.ToOfficeId = toOfficeId;
    this.ToOfficeName = toOfficeName;
    this.Comments = '';
    this.InternalReferenceNumber = '';
  }
}

class EditReverseIobWindowDescription {
  static titleForCreate = 'Create Reverse IOB';
  static titleForEdit = 'Create Reverse IOB';
  static itemType = ReverseIobItem;

  static serviceFunction = (edited) =>
    OutsourcedUserFteService.CreateReverseIob({
      FteEntryIds: edited.FteEntryIds,
      Comments: edited.Comments || null,
      InternalReferenceNumber: edited.InternalReferenceNumber || null,
    });

  static pagesInGeneralEditWizzard = [
    {
      label: 'Reverse IOB Details',
      fields: [
        {
          fieldName: 'ToOfficeName',
          label: 'Bill To Office (reversed)',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'InternalReferenceNumber',
          label: 'Internal Reference Number',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Comments',
          label: 'Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
          numberOfRows: 2,
        },
      ],
    },
  ];
}

export { ReverseIobItem };
export default EditReverseIobWindowDescription;
